import { StateCreator } from 'zustand'
import { InviteLinksState } from '../state'

export interface MarkingModalSlice {
    publisherError: boolean | string
    setPublisherError: (error: boolean | string) => void

    publishOptionError: boolean | string
    setPublishOptionError: (error: boolean | string) => void

    contractError: boolean | string
    setContractError: (error: boolean | string) => void

    eridError: boolean | string
    setEridError: (error: boolean | string) => void

    clearErrors: () => void
}

export const createMarkingModalSlice: StateCreator<
    InviteLinksState,
    [],
    [],
    MarkingModalSlice
> = (set) => ({
    publisherError: false,
    setPublisherError: (error) => set({ publisherError: error }),

    publishOptionError: false,
    setPublishOptionError: (error) => set({ publishOptionError: error }),

    contractError: false,
    setContractError: (error) => set({ contractError: error }),

    eridError: false,
    setEridError: (error) => set({ eridError: error }),

    clearErrors: () =>
        set({
            publisherError: false,
            publishOptionError: false,
            contractError: false,
            eridError: false,
        }),
})
